import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, first } from 'rxjs/operators';
import { TaskResponse, TaskResult, TaskMessage, TaskType, TaskSearchRequest } from '../../_Models/header/task.model';
import { NotificationResponse, NotificationSearchRequest } from '../../_Models/header/notification.model';
import { UserModel } from '../../_Models/user/user.model';
import { UtilityService } from '../common/utility.service';

@Injectable({ providedIn: 'root' })
export class HeaderService {

  url: string;
  public taskList: Array<TaskMessage>;
  private User: UserModel;

  constructor(private http: HttpClient,public utility: UtilityService, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl;

    if (this.url.charAt(this.url.length - 1) == '/')
      this.url = this.url.substring(0, this.url.length - 1);

    if (localStorage.getItem('currentUser'))
      this.User = JSON.parse(localStorage.getItem('currentUser'));

  }

  public getTasks() {

    //var EntityName=this.utility.getEntityName();

    this.http.get<TaskResponse>(`${this.url}/api/user/tasks`)
      .pipe()
      .subscribe(
        res => {
          if (res && res.result == TaskResult.Success) {
            this.taskList = [];
            res.data.map(x => {

              switch (x.type) {
                case TaskType.LeaveToApprove:
                  this.taskList.push(new TaskMessage(x, `Leave request pending - ${x.staffName}, take action.`, `/leaverequest/leave-request/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.ExpenseToApprove:
                  this.taskList.push(new TaskMessage(x, `Expense claim checked - ${x.staffName}, take action.`, `/expenseclaim/expense-claim/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.ExpenseToCheck:
                  this.taskList.push(new TaskMessage(x, `Expense claim pending - ${x.staffName}, take action.`, `/expenseclaim/expense-claim/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.ExpenseToPay:
                  this.taskList.push(new TaskMessage(x, `Expense claim approved - ${x.staffName}, take action.`, `/expenseclaim/expense-claim/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.InspectionVerified:
                  this.taskList.push(new TaskMessage(x, `Inspection booking to Verify - INS ${x.linkId}.`, `/inspedit/edit-booking/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.InspectionConfirmed:
                  this.taskList.push(new TaskMessage(x, `Inspection booking to Confirm - INS ${x.linkId}.`, `/inspedit/edit-booking/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.SplitInspectionBooking:
                  this.taskList.push(new TaskMessage(x, `Inspection booking to Verify (Split from INS - ${x.parentId}) - INS ${x.linkId}.`, `/inspedit/edit-booking/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.ScheduleInspection:
                  this.taskList.push(new TaskMessage(x, `Inspection booking to Schedule - INS ${x.linkId}.`, `/schedule/schedule-summary/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.QuotationPending:
                  this.taskList.push(new TaskMessage(x, `Quotation to be Create   ${x.linkId}.`, `/inspsummary/quotation-pending/3/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.QuotationModify:
                  this.taskList.push(new TaskMessage(x, `Quotation to be Modify  ${x.linkId}.`, `/quotations/edit-quotation/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.QuotationSent:
                  this.taskList.push(new TaskMessage(x, `Quotation to be Sent to Client  ${x.linkId}.`, `/quotations/edit-quotation/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.QuotationCustomerConfirmed:
                  this.taskList.push(new TaskMessage(x, `Quotation to be Validate  ${x.linkId}.`, `/quotations/edit-quotation/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.QuotationCustomerReject:
                  this.taskList.push(new TaskMessage(x, `Quotation to be Re-Send (customer rejected)  ${x.linkId}.`, `/quotations/edit-quotation/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.QuotationToApprove:
                  this.taskList.push(new TaskMessage(x, `Quotation to be Approve  ${x.linkId}.`, `/quotations/edit-quotation/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.UpdateCustomerToFB:
                  this.taskList.push(new TaskMessage(x, `Customer update failed in FB.To recreate  ${x.linkId}.`, `/cusedit/edit-customer/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.UpdateSupplierToFB:
                  this.taskList.push(new TaskMessage(x, `Supplier update failed in FB.To recreate ${x.linkId}.`, `/supplieredit/edit-supplier/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.UpdateSupplierToFB:
                  this.taskList.push(new TaskMessage(x, `Factory update failed in FB.To recreate ${x.linkId}.`, `/supplieredit/edit-supplier/${x.linkId}`, "red-file.svg",null));
                  break;
                case TaskType.UpdateProductToFB:
                  this.taskList.push(new TaskMessage(x, `Product update failed in FB.To recreate  ${x.linkId}.`, `/cusproductedit/edit-customer-product/${x.linkId}`, "red-file.svg",null));
                  break;
              }
            });
          }
          else {
            this.taskList = [];
          }
        },
        error => {
          console.error(error);
        });
  }

  public getNotifications(request : NotificationSearchRequest) {
    return this.http.post<NotificationResponse>(`${this.url}/api/user/notifications`,request)
      .pipe(map(response => {
        return response;
      }));
  }

  public readNotification(id: string) {
    return this.http.get<any>(`${this.url}/api/user/readnotification/${id}`)
      .pipe(map(response => {
        return response;
      }));
  }
  public taskCount(request: TaskSearchRequest){
    return this.http.post<any>(`${this.url}/api/user/taskcount`,request)
      .pipe(map(response => {
        return response;
      }));
  }
  public getTasklist(request: TaskSearchRequest) {
    return this.http.post<TaskResponse>(`${this.url}/api/user/tasklist`,request)
      .pipe(map(response => {
        return response;
      }));
  }
  public notificationCount(request: NotificationSearchRequest){
    return this.http.post<any>(`${this.url}/api/user/notificationcount`,request)
      .pipe(map(response => {
        return response;
      }));
  }
  public readAllNotification() {
    return this.http.get<any>(`${this.url}/api/user/readallnotification`)
      .pipe(map(response => {
        return response;
      }));
  }
  public getFeatureIdByPath(request: any) {
    return this.http.post<any>(`${this.url}/api/user/getApplicationIdByPath`,request)
      .pipe(map(response => {
        return response;
      }));
  }
}
